<template>
	<el-dialog title="操作日志" :visible.sync="visible" :before-close='logStateClose' width="1100px" :close-on-click-modal="false">
		<el-row>
			<el-col :span="10" style="display: flex;align-items: center;">
				<div style="margin-right: 10px;">筛选日期</div>
				<el-date-picker v-model="dateValue" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange">
				</el-date-picker>
			</el-col>
			<el-col :span="5" style="display: flex;align-items: center;">
				<div style="margin-right: 10px;">类型</div>
				<el-select v-model="typeValue" clearable placeholder="请选择" style="width: 130px;" @change="handleChange">
					<el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="4">
				<el-button type="primary" class="addClick" @click="handleResetClick">重置</el-button>
			</el-col>
		</el-row>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="operCategoryType.title" label="类型" :key="1" align="center">
			</el-table-column>
			<el-table-column prop="name" label="时间" :key="2" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.operTime}}</div>
				</template>
			</el-table-column>
			<el-table-column label="操作人" :key="3" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.operation_info.create.create_user.user_name == null?'--':scope.row.operation_info.create.create_user.user_name}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="content" label="事件" :key="4" align="center">
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<page :page="page.page" :total="page.total" @change="changePage" :pageSize="page.pageSize"></page>
	</el-dialog>
</template>
<script>
	import {
		record
	} from "@/api/purchaseApi.js"
	import page from "./page.vue"
	export default {
		components: {
			page
		},
		props: {
			logState: {
				default: false
			},
			shopId: {
				default: ''
			},
			petId: {
				default: ''
			}
		},
		data() {
			return {
				visible: true,
				dateValue: null, //日期
				typeValue: '', //类型筛选
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				typeOption: [{
					label: '宠物转移',
					value: '宠物转移'
				}, {
					label: '宠物接收',
					value: '宠物接受'
				}, {
					label: '修改成长记录',
					value: '修改成长宠物记录'
				}, {
					label: '添加成长记录',
					value: '添加成长宠物记录'
				}, {
					label: '添加宠物',
					value: '添加宠物'
				}],
				tableData: [], //表格数据
				bgnDate:null,  //开始日期
				endDate:null,  //结束日期
			};
		},
		mounted() {
			console.log(this.shopId)
			this.getTableData()
		},
		methods: {
			//类型切换
			handleChange(){
				this.getTableData()
			},
			//日期筛选
			handleDateChange(val){
				// console.log(val)
				if(val == null){
					this.bgnDate = '';
					this.endDate = '';
				}else{
					let bgnDate = val[0].getTime()/1000;
					let endDate = val[1].getTime()/1000;
					console.log(bgnDate,endDate)
					this.bgnDate = bgnDate;
					this.endDate = endDate;
				}
				this.getTableData()
			},
			//格式化时间
			formatDate(time) {
				time = Number(time) * 1000
				let date = new Date(time)
				let Y = date.getFullYear() + '-';
				let M = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-';
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + " ";
				let h = date.getHours() + ':'
				let m = date.getMinutes() + ':'
				let s = date.getSeconds()
				return Y+M+D+h+m+s
			},
			//分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//重置按钮
			handleResetClick() {
				this.bgnDate = '';
				this.endDate = '';
				this.typeValue = '';
				this.dateValue = null;
				this.getTableData();
			},
			//获取操作记录列表
			getTableData() {
				let params = {
					pageIndex: this.page.page,
					pageSize: this.page.pageSize,
					bgnDate: this.bgnDate, //开始日期
					endDate: this.endDate, //结束日期
					operType: this.typeValue, //操作类型
					shopId: this.shopId, //门店id
					petId: this.petId, //宠物id
				}
				record(params).then((res) => {
					console.log(res)
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			//向父组件发射关闭弹框
			logStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
		},
		watch: {
			// 监视状态发生改变
			logState() {
				this.visible = this.logState;
			},
		}
	};
</script>
